/**
 * core/Config
 *
 * Default configuration.
 */

import { noopTrue } from './utils';


export default {
    attribution: 'Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',

    basePath: '/data',

    center: [42.357026, -71.069529],
    colored: true,

    debounce: 200,

    filter: noopTrue,

    marker: {
        color: '#eeeeee',
        opacity: .5,
        radius: 25,
        weight: 2,
    },
    maxZoom: 18,
    minZoom: 5,
    mobile: false,

    name: 'data.json',

    props: {},

    shader: {
        fade: 3,
        seed: 100,
    },

    target: 'body',
    tiles: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',

    zoom: 13,
};
